(() => {
  if (window.cbRingSizeGuideInitialized) return;

  window.cbRingSizeGuideInitialized = true;

  let lastTrigger = null;

  function findDrawer(trigger) {
    const productInfo = trigger?.closest('product-info');

    return (
      productInfo?.querySelector(
        '[data-cb-size-guide-drawer]'
      ) ||
      document.querySelector(
        '[data-cb-size-guide-drawer]'
      )
    );
  }

  function setMethod(drawer, method) {
    if (!drawer) return;

    const methodTriggers = drawer.querySelectorAll(
      '[data-size-method-trigger]'
    );

    const methodPanels = drawer.querySelectorAll(
      '[data-size-method-panel]'
    );

    methodTriggers.forEach((button) => {
      const isActive =
        button.dataset.method === method;

      button.classList.toggle(
        'is-active',
        isActive
      );

      button.setAttribute(
        'aria-selected',
        isActive ? 'true' : 'false'
      );
    });

    methodPanels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.dataset.method === method
      );
    });
  }

  function lockPage() {
    document.documentElement.classList.add(
      'cb-guide-lock'
    );

    document.body.classList.add(
      'cb-guide-lock'
    );
  }

  function unlockPage() {
    document.documentElement.classList.remove(
      'cb-guide-lock'
    );

    document.body.classList.remove(
      'cb-guide-lock'
    );
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    lastTrigger = trigger || null;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    setMethod(drawer, 'method1');
    lockPage();

    window.requestAnimationFrame(() => {
      drawer
        .querySelector(
          '[data-cb-size-guide-close]'
        )
        ?.focus();
    });
  }

  function closeVideo(drawer) {
    if (!drawer) return;

    const videoModal = drawer.querySelector(
      '[data-video-modal]'
    );

    const videoIframe = drawer.querySelector(
      '[data-video-iframe]'
    );

    if (videoIframe) {
      videoIframe.src = '';
    }

    if (videoModal) {
      videoModal.hidden = true;
    }
  }

  function openVideo(drawer, url) {
    if (!drawer || !url) return;

    const videoModal = drawer.querySelector(
      '[data-video-modal]'
    );

    const videoIframe = drawer.querySelector(
      '[data-video-iframe]'
    );

    if (!videoModal || !videoIframe) return;

    const separator = url.includes('?')
      ? '&'
      : '?';

    videoIframe.src =
      `${url}${separator}autoplay=1`;

    videoModal.hidden = false;
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    closeVideo(drawer);
    unlockPage();

    if (
      lastTrigger &&
      document.contains(lastTrigger)
    ) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest(
      '[data-cb-size-guide-open]'
    );

    if (openTrigger) {
      event.preventDefault();

      openDrawer(
        findDrawer(openTrigger),
        openTrigger
      );

      return;
    }

    const methodTrigger = event.target.closest(
      '[data-size-method-trigger]'
    );

    if (methodTrigger) {
      const drawer = methodTrigger.closest(
        '[data-cb-size-guide-drawer]'
      );

      setMethod(
        drawer,
        methodTrigger.dataset.method
      );

      return;
    }

    const videoOpenTrigger =
      event.target.closest('[data-video-open]');

    if (videoOpenTrigger) {
      const drawer = videoOpenTrigger.closest(
        '[data-cb-size-guide-drawer]'
      );

      openVideo(
        drawer,
        videoOpenTrigger.dataset.videoUrl
      );

      return;
    }

    const videoCloseTrigger =
      event.target.closest('[data-video-close]');

    if (videoCloseTrigger) {
      const drawer = videoCloseTrigger.closest(
        '[data-cb-size-guide-drawer]'
      );

      closeVideo(drawer);

      return;
    }

    const closeTrigger = event.target.closest(
      '[data-cb-size-guide-close]'
    );

    if (closeTrigger) {
      event.preventDefault();

      closeDrawer(
        closeTrigger.closest(
          '[data-cb-size-guide-drawer]'
        )
      );
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openDrawerElement =
      document.querySelector(
        '[data-cb-size-guide-drawer].is-open'
      );

    if (!openDrawerElement) return;

    const videoModal =
      openDrawerElement.querySelector(
        '[data-video-modal]'
      );

    if (videoModal && !videoModal.hidden) {
      closeVideo(openDrawerElement);
      return;
    }

    closeDrawer(openDrawerElement);
  });
})();